import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroVideo = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-black overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b35372d59927f92d52c45ba915c9704c.jpg"
          alt="Majestic mountain sunset"
          width={1920}
          height={1080}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-transparent to-black/50"></div>
      </div>

      {/* Floating Geometric Elements */}
      <motion.div
        animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute top-32 right-20 w-32 h-32 border border-gold/30 rounded-full hidden lg:block"
      />
      <motion.div
        animate={{ y: [0, 20, 0], rotate: [0, -5, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute bottom-40 right-40 w-20 h-20 border border-cream/20 hidden lg:block"
      />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="max-w-5xl">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-3 mb-8"
          >
            <div className="w-12 h-[2px] bg-gold"></div>
            <span className="text-gold text-sm font-semibold tracking-widest uppercase">
              Comprehensive Problem Management Solutions
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-6xl md:text-7xl lg:text-8xl font-black text-white leading-[0.95] tracking-tight mb-8"
          >
            <span className="block">Our Proven</span>
            <motion.span
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="block text-gold"
            >
              Solutions
            </motion.span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-xl md:text-2xl text-cream/80 mb-12 max-w-2xl leading-relaxed"
          >
            Discover our comprehensive suite of problem identification, escalation, and awareness programs. 
            Each solution is meticulously designed to ensure your problems receive the attention they deserve.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="flex flex-wrap gap-5"
          >
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 bg-gold text-black px-8 py-4 rounded-full text-base font-bold hover:bg-white transition-all duration-300 whitespace-nowrap"
            >
              Begin Your Journey
              <motion.i className="ri-arrow-right-line text-xl" whileHover={{ x: 5 }} />
            </Link>
            <a
              href="#programs"
              className="group inline-flex items-center gap-3 border-2 border-cream/50 text-cream px-8 py-4 rounded-full text-base font-bold hover:bg-cream hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              View Programs
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="flex flex-col items-center gap-2 text-cream/50"
        >
          <span className="text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-xl"></i>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroVideo;